import React, { Fragment, useState, useEffect, useRef } from "react";
import { Redirect, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Button from "@mui/material/Button";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { Link, Navigate, useNavigate } from "react-router-dom";
import "react-quill/dist/quill.snow.css"; // Add this line
import Lottie from "lottie-react";
import loading from "../components/loading.json";
import { themeStyle, themeStyleDark } from "../components/Components";
import Backdrop from "@mui/material/Backdrop";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { Grid } from "@mui/material";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import VisitUs from "../components/VisitUs";
import CountUp from "react-countup";
import { API_URL } from "../actions/auth";
import axios from "axios";
import "react-quill/dist/quill.core.css";

export default function CasePage() {
  const state = useSelector((state) => state);
  const location = useLocation();
  const [content, setContent] = useState("");
  const [author, setAuthor] = useState("");

  useEffect(() => {
    axios
      .post(API_URL + "get_case_content", {
        slug: location.pathname.split("/")[2].replaceAll("/", ""),
      })
      .then((res) => {
        setContent(res.data["content"]);
        setAuthor(res.data["author"]);
      });
  }, []);

  function getContent() {
    return (
      <div
        className={"anigrad"}
        style={{
          backgroundColor: "white",
          textAlign: "left",
        }}
      >
        <Sidebar />
        <div
          style={{
            display: "flex",
            backgroundColor: "#111",
            marginTop: state.auth.isMobile ? "2.2vh" : "12vh",
            height: "60vh",
            justifyContent: "center",
            backgroundPosition: "center",
            backgroundSize: "cover",
            alignItems: "center",
            width: "100vw",
            backgroundImage:
              "url('" + API_URL + "media/" + content.post_id + ".jpg" + "')",
          }}
        ></div>
        <div
          style={{
            backgroundColor: "white",
            width: "100%",
            padding: "15px",
          }}
        >
          <Grid container>
            <Grid item xs={0} md={2}></Grid>
            <Grid item xs={12} md={8}>
              <h1
                style={{
                  color: "black",
                }}
              >
                {content.title}
              </h1>
              <div
                className="ql-editor"
                dangerouslySetInnerHTML={{ __html: content.content }}
              />
            </Grid>
            <Grid item xs={0} md={2}></Grid>
          </Grid>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
